import React, { useEffect, useRef } from 'react';
import {Button, Card, Dialog} from '@betareader/design-system';

import { useTranslation } from 'react-i18next';

import {useDispatch, useSelector} from '../../../reduxHooks';

import firebase from '../../../config/fire';
import { resetActiveAccount, setActiveAccount } from '../../../modules/account';

import { loggedOut } from '../../../modules/user';
import { useHostAppProxy } from 'src/contexts/HostAppProxyContext';

const LAST_ACTIVE_ACCOUNT_KEY = 'br-laa';

const AccountSelector = () => {
  const { t } = useTranslation();
  const { signOut } = useHostAppProxy();
  const dispatch = useDispatch();
  const userProfile = useSelector((state: any) => state.user.userProfile);
  const activeAccount = useSelector(
    (state: any) => state.account.activeAccount
  );

  const restoredSavedAccount = useRef(false);

  useEffect(() => {
    const memberships = userProfile?.accountMembership || [];
    if (memberships.length === 0) {
      if (activeAccount) dispatch(resetActiveAccount());
      return;
    }
    const selectedId =
      activeAccount?._id ||
      (!restoredSavedAccount.current
        ? window.localStorage.getItem(LAST_ACTIVE_ACCOUNT_KEY)
        : undefined);
    restoredSavedAccount.current = true;
    const membership =
      memberships.find((item: any) => item.account._id === selectedId) ||
      (memberships.length === 1 ? memberships[0] : undefined);
    const account = membership?.account;
    if (account && account !== activeAccount) {
      window.localStorage.setItem(LAST_ACTIVE_ACCOUNT_KEY, account._id);
      dispatch(setActiveAccount({ account }));
    } else if (!account && activeAccount) {
      dispatch(resetActiveAccount());
    }
  }, [userProfile, activeAccount, dispatch]);

  const _setActiveAccount = (account: any) => {
    window.localStorage.setItem(LAST_ACTIVE_ACCOUNT_KEY, account._id);
    dispatch(setActiveAccount({ account }));
  };

  const handleSignout = () => {
    dispatch(resetActiveAccount());
    dispatch(loggedOut());
    signOut();
    firebase.auth().signOut();
  };

  if (
    !userProfile ||
    activeAccount ||
    !userProfile.accountMembership ||
    userProfile.accountMembership.length === 0
  ) {
    return null;
  }

  return (
    <Dialog open title={t('Account')} onClose={() => {}}
      actions={<Button variant='secondary' onClick={handleSignout}>{t('SignOut')}</Button>}>
        <div style={{display: 'grid', gap: 'var(--br-space-3)'}}>
          {userProfile.accountMembership.map((membership: any) => (
            <Card
              key={membership.account._id}
              style={{padding: 'var(--br-space-3)'}}>
              <Button variant='secondary' onClick={() => _setActiveAccount(membership.account)}>
                {membership.account.owner.displayName}
              </Button>
              <p>{t(`member_role_${membership.role}`)}</p>
            </Card>
          ))}
        </div>
    </Dialog>
  );
};

export default AccountSelector;
